<div class="search-display-container" #container>
  <!-- Toolbar -->
  <mat-toolbar class="display-toolbar">
    <ng-container *ngIf="!searchState?.query && (!searchState?.results || searchState.results.length === 0)">
      <mat-icon class="toolbar-icon">grid_view</mat-icon>
      <span class="toolbar-title">Grid View</span>
      <div class="toolbar-spacer"></div>
    </ng-container>

    <!-- Search Summary Panel -->
    <app-search-summary-panel [searchState]="searchQueryService.searchState$ | async" [config]="searchPanelConfig"></app-search-summary-panel>
  </mat-toolbar>

  <!-- Content Area -->
  <div class="display-content display-content--centered">
    <!-- Results Grid (only visible if there are results) -->
    <app-grid-search-results *ngIf="searchState?.loading || searchState?.results?.length || searchState?.error" [parentSize]="containerSize"></app-grid-search-results>

    <!-- Empty State (at same level as grid-results) -->
    <ng-container *ngIf="!searchState?.loading && (!searchState?.results || searchState.results.length === 0) && !searchState?.error">
      <div class="landing-section">
        <div class="landing-header">
          <mat-icon class="landing-icon">search</mat-icon>
          <h2 class="landing-title">Search Reality</h2>
          <p class="landing-description">Use the search box above to find specific features in aerial imagery using AI-powered semantic search</p>
        </div>
        <!-- Example Searches - hidden entirely until a valid geofencing area is configured -->
        @if ((geofencingValidation$ | async); as geofencing) {
          @if (!geofencing.valid) {
            <div class="chips-section">
              <p class="landing-description">{{ geofencing.reason }}</p>
              <button matButton="tonal" color="primary" class="mt-2" (click)="openGeofencingDialog()">
                <mat-icon>crop_free</mat-icon>
                Configure geofencing
              </button>
            </div>
          } @else {
            <div class="chips-section">
              <h3 class="chips-section-title">Try these example searches:</h3>
              <div class="chips-container">
                <mat-chip-set>
                  <mat-chip-option (click)="performSuggestionSearch('swimming pool')" class="suggestion-chip">Try: "swimming pool"</mat-chip-option>
                  <mat-chip-option (click)="performSuggestionSearch('solar panels')" class="suggestion-chip">Try: "solar panels"</mat-chip-option>
                  <mat-chip-option (click)="performSuggestionSearch('parking lot')" class="suggestion-chip">Try: "parking lot"</mat-chip-option>
                </mat-chip-set>
              </div>
            </div>
          }
        }
      </div>
    </ng-container>
  </div>
</div>
